export function SplideLabels( Splide, Components ) {
    let labels;
    let labels_list = [];

    function mount() {
        const slides = Components.Elements.slides;
			Components.Pagination.items.forEach( (item, i) => {
                const label = document.createElement('div');
                label.className = 'splide__label';
                const image = slides[i].getElementsByTagName('img')[0];
                if (image) {
                    setTimeout(() => {
                        label.append(image.getAttribute('alt'));    
                        item.button.append(label);
                    }, 100)
                }
            } );
      }
    
    
    
      return {
        mount
      };
	
}